import { createFeatureSelector, createSelector } from '@ngrx/store';
import { State } from '@app/store';
import * as RouteRedirectState from './route-redirect.state';

export const featureSelector = createFeatureSelector<
  RouteRedirectState.State
>('routeRedirectState');

export const getCallingRoute = createSelector(
  featureSelector,
  ({ url, queryParams }: RouteRedirectState.State) => ({
    url,
    queryParams
  })
);
